module.exports = __webpack_public_path__ + "static/media/splitboarding-with-rainier.081b0fa1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/splitboarding-with-rainier.jpg
// module id = 945
// module chunks = 0